/**
 * Jembatan halaman embed → aplikasi mobile OneLNK (react-native-webview).
 *
 * Kontraknya milik aplikasi mobile (mobile-oneworkspace
 * docs/pedoman-deep-link-approval.md §3.4) dan sama dengan
 * `src/utils/embedBridge.ts` di fe-web-dcis-new dan fe-asset-opname.
 *
 * - `onelnk.embed.busy`: tahan penutup loading; `ready` atau navigasi pasti
 *   menyusul. Hanya dikirim di titik seperti itu: sebelum login dari cookie,
 *   sebelum pindah ke /login, dan saat halaman approval mulai membuka deep link.
 * - `onelnk.embed.ready`: modal sudah terbuka, ATAU pesan galat sudah tampil.
 *   Tanpa sinyal ini saat gagal, penutup loading menggantung sampai pengaman
 *   waktu aplikasi habis dan pesannya tidak pernah terbaca.
 * - `onelnk.approval.closed`: modal ditutup atau keputusan dikirim; aplikasi
 *   kembali ke inbox dan menarik ulang daftarnya.
 *
 * Di peramban biasa `window.ReactNativeWebView` tidak ada, jadi semuanya no-op.
 */

export const EMBED_BUSY_TYPE = 'onelnk.embed.busy';
export const EMBED_READY_TYPE = 'onelnk.embed.ready';
export const APPROVAL_CLOSED_TYPE = 'onelnk.approval.closed';

/** Bridge WebView bila ada dan berbentuk benar; null di peramban biasa. */
export const getNativeBridge = (host = typeof window === 'undefined' ? undefined : window) => {
	const bridge = host?.ReactNativeWebView;
	return bridge && typeof bridge.postMessage === 'function' ? bridge : null;
};

const kirim = (pesan, isEmbed, bridge) => {
	if (!isEmbed || !bridge) return false;
	try {
		bridge.postMessage(JSON.stringify(pesan));
		return true;
	} catch (e) {
		// Bridge rusak tidak boleh menjatuhkan halaman; aplikasi punya pengaman waktu.
		return false;
	}
};

/** @returns {boolean} true hanya bila pesan benar-benar terkirim */
export const notifyEmbedBusy = ({ isEmbed, bridge = getNativeBridge() }) =>
	kirim({ type: EMBED_BUSY_TYPE }, isEmbed, bridge);

/** @returns {boolean} true hanya bila pesan benar-benar terkirim */
export const notifyEmbedReady = ({ isEmbed, bridge = getNativeBridge() }) =>
	kirim({ type: EMBED_READY_TYPE }, isEmbed, bridge);

/**
 * @param {{id: string, result: 'closed'|'submitted', isEmbed: boolean, bridge?: object}} opsi
 * @returns {boolean} true hanya bila pesan benar-benar terkirim
 */
export const notifyEmbedApprovalClosed = ({ id, result, isEmbed, bridge = getNativeBridge() }) =>
	kirim({ type: APPROVAL_CLOSED_TYPE, id: String(id ?? ''), result }, isEmbed, bridge);
